import { getSessionToken, startImpersonationSession } from '../auth';
import { findStartPage } from '../../config/startPages';
import { impersonateStaff } from './staffApi';

/**
 * Вход под сотрудником точки из «Пользователей». Право users.staff.impersonate, зону точки и статусы
 * проверяет сервер; администратор вернётся в «Пользователи», как после входа под обычным пользователем.
 */
export async function impersonateStaffAndRedirect(staffId: number): Promise<void> {
  // Сервер определяет оператора только по токену сессии; без него запрос заведомо будет отклонен
  if (!getSessionToken()) throw new Error('Сессия не найдена, войдите в систему заново');

  const data = await impersonateStaff(staffId);
  if (!data.sessionToken || !data.impersonator) throw new Error('Сервер не вернул сессию сотрудника');

  const usersTab = findStartPage('admin', 'users');
  startImpersonationSession(data, data.impersonator, usersTab ? `/admin?tab=${usersTab.index}` : '/admin');
  window.location.href = data.targetInterface === 'admin' ? '/admin' : '/dashboard';
}
